import { FollowButton } from '@/components';
import { useUserDetail } from '@/hooks';
import React from 'react';
import style from './index.module.css';
import { IconHiStar } from '@/assets/hi';
import { useTranslation } from 'react-i18next';

export interface HiFollowFixTipProps {
  address: string;
}

export const HiFollowFixTip = ({ address }: HiFollowFixTipProps) => {
  const { data: addrInfo, isLoading } = useUserDetail(address);
  const { t } = useTranslation();

  if (isLoading) return null;
  const isStranger = !addrInfo?.is_following && !addrInfo?.is_followed;
  const canFollowBack = !addrInfo?.is_following && addrInfo?.is_followed;
  const displayText = isStranger
    ? t('HiFollowFixTip.stranger')
    : canFollowBack
      ? t('HiFollowFixTip.canfollowback')
      : '';

  return addrInfo?.is_following ? null : (
    <div className={style.fixTip}>
      <div className={style.tipArea}>
        <IconHiStar style={{ marginRight: 8 }} />
        <span className={style.tipText}>{displayText}</span>
      </div>
      <FollowButton className={style.followBtn} userInfo={addrInfo} address={address} />
    </div>
  );
};
